module.exports = "div.height-fix {\n  height: 200px;\n  overflow: hidden;\n  margin-bottom: 1.5em;\n  cursor: pointer; }\n  div.height-fix img {\n    min-height: 200px; }\n\n@media (min-width: 768px) and (max-width: 991px) {\n  div.height-fix {\n    height: 160px;\n    margin-bottom: 1em; }\n    div.height-fix img {\n      min-height: 160px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/gallery.component.scss
// module id = 239
// module chunks = 1